import React from 'react'
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemText';
import styled, { css } from 'styled-components';
import _ from 'lodash';

const Container = styled.div`
    width:100%
    display:grid;
    grid-template-columns:1fr 100px;
    cursor: pointer;
`
const ProjectText = styled.div`
    font-size:14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;

`;

// const ActionCount = styled.div`
//     cursor: pointer;
//     textAlign:'right';
//     fontSize:15;
//     padding-left:20px;
//     font-weight:300;
//     ${props =>
//         props.hasActions &&
//         css`
//         font-weight:500;
//         `};
// `;

function ProjectSearchListItem(props) {
    let project = JSON.parse(props.children);

    // const isAssigned = _.find(project.functions,{isAssigned:true});
    // const actionsCount = project.functions.reduce( (actionsCount,aFunction) => actionsCount + aFunction.actions,0 );
    
    return (
      <ListItem
        selected={props.isFocused}
        component="div"
        style={{
          fontWeight: props.isSelected ? 500 : 400,
          fontSize : 12
        }}
        {...props.innerProps}
      >
        <ProjectText>
            {project && project.preferredName ? project.preferredName : project.name}
        </ProjectText> 

        {/* {isAssigned ?  
          <Container>    
         <ProjectText>
              {project.name}
          </ProjectText>          
            <ActionCount hasActions={actionsCount}>
            {`${actionsCount} Actions`}
            </ActionCount>
          </Container>
          :
          <ProjectText>
              {project.name}
          </ProjectText>
        } */}
      </ListItem>
    )
}

export default ProjectSearchListItem
